import { FC } from 'react';
import * as R from 'ramda';
import { Connection, Handle, NodeProps, Position } from 'react-flow-renderer';
import Node, { contentStyle, contentStyle as style } from './Node';
import { Badge, Box, Icon, Tooltip, Typography } from '@mui/material';

const isValidInput = (connection: Connection, isOnline: boolean) => {
  return !isOnline ? R.split('_', connection.source as string)[0] === 'inicio'
    : (R.split('_', connection.source as string)[0] === 'inicio'
      || R.split('_', connection.source as string)[0] === 'condicional'
      || R.split('_', connection.source as string)[0] === 'sleep');
};
const isValidOutput = (connection: Connection) => {
  return (R.last(R.split('__', connection.targetHandle as string)) === R.last(R.split('__', connection.sourceHandle as string))
    || (R.split('_', connection.target as string)[0] === 'fim'));
};

export const CampanhaNode: FC<NodeProps> = ({ data, selected, }) => {
  const listCanais: string[] = data.campanhaCanais ? data.campanhaCanais.split(' , ') : [];
  const isOnline: boolean = data.cmpOnline ? data.cmpOnline : false;
  return (
    <Badge badgeContent={data.erros | 0} color="error">

      <Node
        label='Campanha'
        icon='campaign'
        selected={selected}
        color={isOnline ? '#808000' : '#8E95BF'}
        content={
          <>
            {data.campanhaId && (
              <Box style={contentStyle.io}>
                <Handle
                  type='target'
                  position={Position.Left}
                  id='i__data'
                  style={{ ...style.handle, ...style.left }}
                  isValidConnection={(con) => isValidInput(con, isOnline)}
                />
                <Tooltip title={data.campanhaNome} followCursor>

                  <Typography style={{ fontSize: '12px', }} noWrap>
                    {`${data.campanhaId} - ${data.campanhaNome}`}
                  </Typography>
                </Tooltip>
              </Box>
            )}

            <Box style={contentStyle.contentHeader}>
              <Typography style={{ fontSize: '12px', }} noWrap={true}>
                {data.label}
              </Typography>
            </Box>

            {data.campanhaId && (<>

              {listCanais.map((canal) => (
                <Box
                  key={`o-${canal}`}
                  style={{ ...style.io, ...style.textRight }}
                >
                  {canal}
                  <Handle
                    type='source'
                    position={Position.Right}
                    id={`o-cmp__${canal}`}
                    style={{ ...style.handle, ...style.right }}
                    isValidConnection={isValidOutput}
                  />
                </Box>
              ))}

            </>)}
          </>
        }
      />
    </Badge>
  );
};
